/* eslint-disable max-params */
/* global _ */
module.exports = ['$scope', 'curriculumManager', 'bibContentManager', '$location', '$q', '$state', '$stateParams', '$notification', 'messages', 'ngMeta', 'settings', '$rootScope',
  function ($scope, curriculumManager, bibContentManager, $location, $q, $state, $stateParams, $notification, messages, ngMeta, settings, $rootScope) {
    'use strict';
    $scope.$parent.hideSearchBar = false;

    ngMeta.setTitle('Bib: illustraties');

    // If user already selected a field, theme, goal age range or query, keep it selected...
    // ...except if it comes from the concordanties page.
    $scope.$parent.selected = $scope.$parent.selected && $rootScope.previousState !== 'bib.search.concordanties' ? $scope.$parent.selected : {};
    $scope.$parent.options = {};
    $scope.options = {};
    $scope.results = [];
    $scope.selected = {};
    $scope.$parent.loaded = false;
    $scope.searching = true;

    //result configuration
    $scope.limit = 8;
    $scope.currentOffset = parseInt($stateParams.offset || 0);

    function sort(key) {
      switch (key) {
      case 0: $scope.results = _.orderBy($scope.results, function (o) { return o.created; }, 'desc'); break;
      case 1: $scope.results = _.orderBy($scope.results, function (o) { return o.title; }, 'asc'); break;
      default: break;
      }
    }

    //Search for content based on filters
    $scope.$parent.search = function (overwriteOffset) {
      $scope.searching = true;
      if (overwriteOffset) {
        $scope.currentOffset = overwriteOffset;
        $location.search('offset', overwriteOffset);
      } else if(overwriteOffset === 0) {
        $location.search('offset', '0');
      }
      var typeparam = [];
      var qparam;
      var contentRoot = $q.defer();
      var contentRootProm = contentRoot.promise;
      //$scope.results = [];
      $scope.searching = true;
      if ($scope.$parent.selected.goal && $scope.$parent.selected.goal.type === 'goal') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.goal.key);
      } else if ($scope.$parent.selected.theme && $scope.$parent.selected.theme.type === 'theme') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.theme.key);
      } else if ($scope.$parent.selected.field && $scope.$parent.selected.field.type === 'field') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.field.key);
      } else if ($scope.$parent.selected.field.key === '0') {
        contentRoot.resolve(null);
      }


      if ($scope.$parent.selected.q) {
        qparam = $scope.$parent.selected.q;
      }

      contentRootProm.then(function (root) {
        var contentFilters = {
          limit: $scope.limit,
          offset: $scope.currentOffset,
          relatedToCurriculumContent: root
        };
        if(!(parseInt($scope.$parent.selected.ageFrom) === 2 && parseInt($scope.$parent.selected.ageTo) === 12)) {
          contentFilters.minAge = $scope.$parent.selected.ageFrom;
          contentFilters.maxAge = $scope.$parent.selected.ageTo;
        }

        bibContentManager.getContentUnder(root, ['ZILL_ILLUSTRATION'], qparam, contentFilters).then(function (results) {
          $scope.searching = false;
          $scope.results = results;
          results.forEach(function (result) {
            result.goals = [];
            if (result.referencedGenericGoals) {
              result.referencedGenericGoals.forEach(function (referencedGoal) {
                curriculumManager.getGoalByHref(referencedGoal.href).then(function (goal) {
                  if (typeof goal != 'undefined' && $scope.$parent && $scope.$parent.selected) {
                    if ($scope.$parent.selected.field.key === '0') {
                      result.goals.push(goal);
                    } else if ($scope.$parent.selected.theme.key === '0') {
                      if ($scope.$parent.selected.field && $scope.$parent.selected.field.type === 'field' && $scope.$parent.selected.field.key === goal.theme.field.key) {
                        result.goals.push(goal);
                      }
                    } else if ($scope.$parent.selected.goal.key === '0') {
                      if ($scope.$parent.selected.theme && $scope.$parent.selected.theme.type === 'theme' && $scope.$parent.selected.theme.key === goal.theme.key) {
                        result.goals.push(goal);
                      }
                    } else if ($scope.$parent.selected.goal && goal.key === $scope.$parent.selected.goal.key) {
                      result.goals.push(goal);
                    }
                  }
                });
              });
            }

            result.fieldsPracticalExample = [];
            if(result.practicalExample.referencedGenericGoals) {
              result.practicalExample.referencedGenericGoals.forEach(function (goal) {
                var fieldHref = goal.ancestors.find(ancestor => ancestor.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD').href;

                curriculumManager.getFieldByHref(fieldHref).then(function (field) {
                  if (typeof field != 'undefined' && !result.fieldsPracticalExample.some(fieldAlreadyPushed => fieldAlreadyPushed.key === field.key)) {
                    result.fieldsPracticalExample.push(field);
                  }
                });
              });
            }
            if (result.practicalExample.thumbnail) {
              result.thumb = settings.apisAndUrls.cachedApi + result.practicalExample.thumbnail;
            }
          });
        }, function () {
          $notification.error(messages.search.error);
        });
      },
      function () {
        $notification.error(messages.search.error);
        $scope.results = [];
      });
    };

    //all static options
    var options = {
      field: [
        {
          key: '0',
          type: 'static',
          icon: 'fa-archive',
          color: '#000000',
          title: 'volledige bib'
        }
      ],
      goal: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen doel'
        }
      ],
      theme: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen thema'
        }
      ],
      type: [
        {
          key: 0,
          title: 'alle items'
        },
        {
          key: 'DOCUMENT',
          title: 'visie tekst (test)'
        },
        {
          title: 'kijkwijzers'
        },
        {
          title: 'schema\'s'
        },
        {
          title: 'stappenplannen'
        },
        {
          title: 'max 5 per veld'
        }
      ]
    };

    $scope.options.sort = [
      {
        key: 0,
        title: 'nieuwste'
      },
      {
        key: 1,
        title: 'alfabetisch'
      },
      {
        key: 2,
        title: 'integratiegraad'
      },
      {
        key: 3,
        title: 'leeftijd'
      }
    ];

    //Function to load all posible options
    // noinspection JSNonStrictModeUsed
    function loadOptions(fields) {
      $scope.selected.sort = $scope.options.sort[0];

      //add fields to field options
      fields.forEach(function (value) {
        options.field.push({
          type: 'field',
          key: value.key,
          title: value.title,
          color: value.color,
          iconUrl: value.iconUrl,
          themes: value.themes.map(function (theme) {
            return {
              type: 'theme',
              key: theme.key,
              title: theme.title,
              goals: theme.goals.map(function (goal) {
                return {
                  type: 'goal',
                  key: goal.key,
                  title: goal.title,
                  code: goal.code
                };
              })
            };
          })
        });
      });

      options.field.forEach(function (field) {
        if(field.type === 'field' && field.themes) {
          field.themes = _.concat(options.theme, field.themes);
          field.themes.forEach(function (theme) {
            if (theme.goals && theme.type === 'theme') {
              theme.goals = _.concat(options.goal, theme.goals);
            }
          });
        }
      });

      $scope.$parent.options = options;
      $scope.$state = $state;

      if ($stateParams.from) {
        curriculumManager.getFieldByHref('/content/' + $stateParams.from
        ).then(function (field) {
          if (!field) {
            curriculumManager.getThemeByHref('/content/' + $stateParams.from
            ).then(function (theme) {
              if (!theme) {
                curriculumManager.getGoalByHref('/content/' + $stateParams.from
                ).then(function (goal) {
                  if (goal) {
                    $scope.from = goal;
                    $scope.from.state = 'leerinhoud.goal';
                    $scope.from.params = {fieldKey: goal.theme.field.identifiers[0], themeKey: goal.theme.identifiers[0], goalKey: goal.identifiers[0]};
                  }
                });
              } else {
                $scope.from = theme;
                $scope.from.state = 'leerinhoud.theme';
                $scope.from.params = {fieldKey: theme.field.identifiers[0], themeKey: theme.identifiers[0]};
              }
            });
          } else {
            $scope.from = field;
            $scope.from.state = 'leerinhoud.field';
            $scope.from.params = {fieldKey: field.identifiers[0]};
          }
        });
      }

      // $scope.$parent.selected includes multiple values, and some of them are later consumed in the template.
      // Among them, there are values for the selectors and inputs of the search form.
      // The default values are set in the following way:
      // search parameters > already selected values > first value in the list of options.
      if ($stateParams.type && _.findIndex($scope.$parent.options.type, function (o) { return o.key === $stateParams.type; }) > -1) {
        $scope.$parent.selected.type = _.find($scope.$parent.options.type, function (o) { return o.key === $stateParams.type; });
      } else {
        $scope.$parent.selected.type = $scope.$parent.selected.type ? $scope.$parent.selected.type : $scope.$parent.options.type[0]; //set first as selected
      }

      if ($stateParams.field && _.findIndex($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; }) > -1) {
        $scope.$parent.selected.field = _.find($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; });
      } else {
        $scope.$parent.selected.field = $scope.$parent.selected.field ? $scope.$parent.selected.field : $scope.$parent.options.field[0]; //set first as selected
      }

      if ($stateParams.ageFrom) {
        $scope.$parent.selected.ageFrom = $stateParams.ageFrom;
      } else {
        // TODO move default values to constants
        $scope.$parent.selected.ageFrom = $scope.$parent.selected.ageFrom ? $scope.$parent.selected.ageFrom : 2;
      }

      if ($stateParams.ageTo) {
        $scope.$parent.selected.ageTo = $stateParams.ageTo;
      } else {
        // TODO move default values to constants
        $scope.$parent.selected.ageTo = $scope.$parent.selected.ageTo ? $scope.$parent.selected.ageTo : 12;
      }


      if($scope.$parent.selected.field.themes) {
        if ($stateParams.theme && _.findIndex($scope.$parent.selected.field.themes, function (o) {
          return o.key === $stateParams.theme;
        })) {
          $scope.$parent.selected.theme = _.find($scope.$parent.selected.field.themes, function (o) {
            return o.key === $stateParams.theme;
          });
        } else {
          $scope.$parent.selected.theme = $scope.$parent.selected.theme ? $scope.$parent.selected.theme : $scope.$parent.selected.field.themes[0]; //set first as selected
        }
      }

      if($scope.$parent.selected.theme && $scope.$parent.selected.theme.goals) {
        if ($stateParams.goal && _.findIndex($scope.$parent.selected.theme.goals, function (o) {
          return o.key === $stateParams.goal;
        })) {
          $scope.$parent.selected.goal = _.find($scope.$parent.selected.theme.goals, function (o) {
            return o.key === $stateParams.goal;
          });
          if($scope.$parent.selected.goal.key != 0) {
            curriculumManager.getGoalByHref('/content/' + $scope.$parent.selected.goal.key
            ).then(function (goal) {
              if (goal) {
                $scope.toGoal = goal;
                $scope.toGoal.state = 'leerinhoud.goal';
                $scope.toGoal.params = {
                  fieldKey: goal.theme.field.identifiers[0],
                  themeKey: goal.theme.identifiers[0],
                  goalKey: goal.identifiers[0]
                };
              }
            });
          }
        } else {
          $scope.$parent.selected.goal = $scope.$parent.selected.goal ? $scope.$parent.selected.goal : $scope.$parent.selected.theme.goals[0]; //set first as selected
          $scope.toGoal = null;
        }
      }


      if ($stateParams.q) {
        $scope.$parent.selected.q = $stateParams.q;
      }
    }

    //When curriculum is loaded, update options ect
    curriculumManager.getFields().then(function (fields) {
      $scope.fields = fields;

      loadOptions(fields); //load all options
      $scope.$parent.loaded = true;
      $scope.$parent.search();
    });

    $scope.$watch('selected.sort', function (newVal) {
      if (newVal) {
        sort(newVal.key);
      }
    }, true);

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/illustrations/bibIllustrationsController.js